import { Component } from "react"
import Navigation from "../Components/Navigation";

class RomanNumeralsKata extends Component {
    render() {
        return (
            <div>
                <Navigation path="katas" />
                <div className="container">
                    <h1>Roman Numerals Kata</h1>
                    <div className="description">
                        <img src="/img/katas/kata_romannumerals.png" alt="Roman Numerals Kata" align="left" />
                        <p>
                            The Romans wrote their numbers using letters; specifically the letters 'I' meaning '1', 'V' meaning '5', 'X' meaning '10', 'L' meaning '50', 'C' meaning '100', 'D' meaning '500', and 'M' meaning '1000'. There were certain rules that the numerals followed which should be observed.
                        </p>
                        <p>
                            The symbols 'I', 'X', 'C', and 'M' can be repeated at most 3 times in a row. The symbols 'V', 'L', and 'D' can never be repeated. The '1' symbols ('I', 'X', and 'C') can only be subtracted from the 2 next highest values ('IV' and 'IX', 'XL' and 'XC', 'CD' and 'CM'). Only one subtraction can be made per numeral ('XC' is allowed, 'XXC' is not). The '5' symbols ('V', 'L', and 'D') can never be subtracted.
                        </p>
                        <p>
                            You can read more about <a href="https://en.wikipedia.org/wiki/Roman_numerals" target="_blank" rel="noopener noreferrer">Roman Numerals</a> on Wikipedia.
                        </p>
                    </div>
                    <hr />
                    <div className="features">
                        <div className="feature">
                            <h2>Feature 1 - Converting Arabic to Roman</h2>
                            <p>
                                We would like to be able to convert Arabic numbers into their Roman numeral equivalents. We just need some kind of program that can accept a numeric input and output the Roman numeral for the input number.
                            </p>
                            <div className="row">
                                <div className="card">
                                    <h3>Convert Arabic Number to Roman Numeral</h3>
                                    <div className="card-contents">
                                        <p>
                                            As a game developer<br />
                                            I want to be able to convert a number to a numeral<br />
                                            So that I can label my game releases using Roman numerals
                                        </p>
                                        <ul>
                                            <li>
                                                Given I have started the converter<br />
                                                When I enter $number<br />
                                                Then $numeral is returned
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="test-cases">
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <th>Number</th>
                                                    <th>Numeral</th>
                                                </tr>
                                                <tr>
                                                    <td>1</td>
                                                    <td>I</td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>III</td>
                                                </tr>
                                                <tr>
                                                    <td>9</td>
                                                    <td>IX</td>
                                                </tr>
                                                <tr>
                                                    <td>1066</td>
                                                    <td>MLXVI</td>
                                                </tr>
                                                <tr>
                                                    <td>1989</td>
                                                    <td>MCMLXXXIX</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="feature">
                            <h2>Feature 2 - Converting Roman to Arabic</h2>
                            <p>
                                The change from the Arabic numbering system to using Roman numerals has gone really well, all things considered. There is a slight issue in that sales of the latest games have dropped off, and when questioned people have said it's because they no longer know what the latest version is, as there's no easy to read number. To remedy this, we are going to install Roman numeral to Arabic number converters everywhere we sell games, so people can work out which is the latest game.
                            </p>
                            <div className="row">
                                <div className="card">
                                    <h3>Convert Roman Numeral to Arabic Number</h3>
                                    <div className="card-contents">
                                        <p>
                                            As a marketing manager<br />
                                            I want customers to be able to convert numerals to numbers<br />
                                            So that they can buy the latest version of the game
                                        </p>
                                        <ul>
                                            <li>
                                                Given I have started the converter<br />
                                                When I enter $numeral<br />
                                                Then $number is returned
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="test-cases">
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <th>Numeral</th>
                                                    <th>Number</th>
                                                </tr>
                                                <tr>
                                                    <td>I</td>
                                                    <td>1</td>
                                                </tr>
                                                <tr>
                                                    <td>III</td>
                                                    <td>3</td>
                                                </tr>
                                                <tr>
                                                    <td>IX</td>
                                                    <td>9</td>
                                                </tr>
                                                <tr>
                                                    <td>MLXVI</td>
                                                    <td>1066</td>
                                                </tr>
                                                <tr>
                                                    <td>MCMLXXXIX</td>
                                                    <td>1989</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row katas" />
            </div>
        );
    }
}

export default RomanNumeralsKata;
